document.addEventListener('DOMContentLoaded', function () {
    // We need to get the section ID dynamically or handle it generally
    // Since this is an asset file, it runs once.
    // We can look for all distributor sections or rely on the fact that variables are passed in some other way.
    // However, the original script used {{ section.id }} liquid variable.
    // We should modify the liquid to pass this ID to a data attribute on the section container,
    // and then this script can find all such containers and initialize them.

    const sections = document.querySelectorAll('.distributor-section');

    sections.forEach(section => {
        const sectionId = section.id; // The liquid already puts id="{{ section.id }}" on the section tag? 
        // Wait, liquid puts it on the section TAG if we use presets? No, usually it's a div inside.
        // In this file: <section class="distributor-section section" id="{{ section.id }}">
        // So section.id is the ID of the element.

        const formLoading = section.querySelector('.form-loading');
        const formIframe = section.querySelector('.form-iframe');
        const pxForm = section.querySelector('.pxFormGenerator');

        if (formIframe) {
            // Iframe form handling
            formIframe.addEventListener('load', function () {
                if (formLoading) {
                    formLoading.style.display = 'none';
                }
                formIframe.style.display = 'block';

                // Try to adjust iframe content
                try {
                    if (formIframe.contentWindow) {
                        const iframeDoc = formIframe.contentDocument || formIframe.contentWindow.document;
                        if (iframeDoc) {
                            iframeDoc.body.style.overflow = 'hidden';
                            iframeDoc.documentElement.style.overflow = 'hidden';
                        }
                    }
                } catch (e) {
                    // Cross-origin restrictions are normal
                    console.log('Form iframe loaded successfully');
                }
            });

            // Show iframe after a timeout as fallback
            setTimeout(function () {
                if (formLoading && formLoading.style.display !== 'none') {
                    formLoading.style.display = 'none';
                    if (formIframe) formIframe.style.display = 'block';
                }
            }, 5000);
        }

        // Handle pxFormGenerator
        if (pxForm && formLoading) {
            // Check if pxFormGenerator has loaded content
            const checkFormLoaded = setInterval(function () {
                if (pxForm.children.length > 0 || pxForm.offsetHeight > 100) {
                    formLoading.style.display = 'none';
                    clearInterval(checkFormLoaded);
                }
            }, 500);

            // Fallback - hide loading after 5 seconds
            setTimeout(function () {
                formLoading.style.display = 'none';
                clearInterval(checkFormLoaded);
            }, 5000);
        }

        // Intersection Observer for animations
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.animationPlayState = 'running';
                }
            });
        }, observerOptions);

        section.querySelectorAll('.benefit-item').forEach(item => {
            observer.observe(item);
        });
    });

    // Handle window resize for better form management
    let resizeTimeout;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
            // Refresh form containers on resize
            const forms = document.querySelectorAll('.form-iframe, .px-form-wrapper');
            forms.forEach(form => {
                if (form.offsetHeight < 100) {
                    form.style.height = '99%';
                    setTimeout(() => {
                        form.style.height = '100%';
                    }, 100);
                }
            });
        }, 250);
    });

    // Initialize forms on page load (Generic fallback)
    setTimeout(function () {
        const pendingIframes = document.querySelectorAll('.form-iframe');
        pendingIframes.forEach(iframe => {
            if (iframe.style.display === 'none') {
                iframe.style.display = 'block';
                // Also hide loading if present
                const loading = iframe.closest('.form-container')?.querySelector('.form-loading');
                if (loading) loading.style.display = 'none';
            }
        });
    }, 1000);
});
